// src/components/login-shell/steps/email-login/email-login.hooks.ts
import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../../../contexts/auth/auth-context";

const isValidEmail = (value: string) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

type UseEmailLoginArgs = {
    onGoogleSuccess?: () => void;
    onEmailSuccess?: (email: string) => void;
};

export const useEmailLogin = (
    { onGoogleSuccess, onEmailSuccess }: UseEmailLoginArgs,
) => {
    const { email, setEmail, loading, error: authError, clearPassword } = useAuth();
    const [localEmail, setLocalEmail] = useState(email);
    const [validationError, setValidationError] = useState("");

    useEffect(() => {
        setLocalEmail(email);
    }, [email]);

    const submitGoogle = useCallback(async () => {
        // placeholder for your Google flow
        if (onGoogleSuccess) onGoogleSuccess();
    }, [onGoogleSuccess]);

    const submitEmail = useCallback(async () => {
        const e = (localEmail || "").trim();
        if (!e) {
            setValidationError("Please enter your email");
            return;
        }
        if (!isValidEmail(e)) {
            setValidationError("Please enter a valid email address");
            return;
        }
        setValidationError("");
        setEmail(e);
        clearPassword(); // important: don’t keep stale password when email changes
        if (onEmailSuccess) onEmailSuccess(e);
    }, [localEmail, setEmail, clearPassword, onEmailSuccess]);

    return {
        email: localEmail,
        setEmail: setLocalEmail,
        loading,
        error: validationError || authError,
        submitGoogle,
        submitEmail,
    };
};
